<template>
    <div>
        <div
            id="cpInput"
            ref="cpInput"
            :style="{ 'background-color': selected_swatch }"
            @click="openPopup()"
        >
            <div
                v-if="popup.open"
                id="cpPopup"
                ref="cpPopup"
                :style="{ top: popup.top, left: popup.left }"
            >
                <span
                    v-for="swatch in swatches"
                    :key="swatch"
                    class="cp-swatch"
                    :class="{ selected: selected_swatch === swatch }"
                    :style="{ 'background-color': swatch }"
                    @click="updateSwatch(swatch)"
                ></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            popup: {
                open: false,
                left: "auto",
                top: "auto"
            },
            selected_swatch: null,
            swatches: [
                "#000000",
                "#545454",
                "#737373",
                "#A6A6A6",
                "#D9D9D9",
                "#FFFFFF",
                "#F44336",
                "#E91E63",
                "#9C27B0",
                "#673AB7",
                "#3F51B5",
                "#2196F3",
                "#03A9F4",
                "#00BCD4",
                "#009688",
                "#4CAF50",
                "#8BC34A",
                "#CDDC39",
                "#FFEB3B",
                "#FFC107",
                "#FF9800",
                "#FF5722",
                "#795548",
                "#607D8B"
            ]
        };
    },
    props: {
        value: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        updateSwatch(swatch) {
            if (this.disabled) return;

            this.selected_swatch = swatch;
            this.$emit("input", swatch);
        },
        openPopup() {
            this.positionPopup();
            this.popup.open = true;

            document.addEventListener("click", this.closePopup, true);
        },
        closePopup() {
            this.popup.open = false;

            document.removeEventListener("click", this.closePopup, true);
        },
        positionPopup() {
            const rect = this.$refs.cpInput.getBoundingClientRect();

            this.popup.left = rect.left + rect.width + 10 + "px";
        }
    },
    created() {
        this.selected_swatch = this.value;
    },
    beforeDestroy() {
        this.closePopup();
    }
};
</script>

<style scoped>
#cpInput {
    width: 152px;
    height: 36px;
    /* box-shadow: 0px 4px 12px rgba(35, 38, 43, 0.15); */
    border: 1px solid rgba(35, 38, 43, 0.24);
    border-radius: 4px;
    margin: auto;
}
#cpPopup {
    position: fixed;
    width: 340px;
    height: 220px;
    display: grid;
    background: #fff;
    border: 1px solid #e0e0e0;
    box-shadow: 0px 16px 16px rgba(35, 38, 43, 0.24);
    border-radius: 4px;
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 12px;
    justify-items: center;
    align-items: center;
    padding: 16px;
}

.cp-swatch {
    position: relative;
    width: 40px;
    height: 40px;
    border: 1px solid rgba(35, 38, 43, 0.24);
    border-radius: 4px;
    transition: all 0.2s ease;
}

.cp-swatch.selected,
.cp-swatch:hover {
    box-shadow: 0 0 0 2px #2b98f0, inset 0 0 0 2px #fff;
    border: none;
}

#cpPopup::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 22px;
    top: 6px;
    left: -10px;
    background: center no-repeat url("../../assets/img/color-picker/popup-arrow.svg");
}
</style>
